<script>
    import Icon from "@iconify/svelte";
    import UserCard from "./UserCard.svelte";
    import { api_post } from "../util/api_request";

    export let user_data;

    export let response;

    let ban_user = async (state) => {
        response = await api_post("/api/admin/set_user_banned", { mc_uuid: user_data.mc_uuid, state: state });
        if (response.status == 200)
            user_data.banned = state;
    }

    let make_donor = async (state) => {
        response = await api_post("/api/admin/set_user_donor", { mc_uuid: user_data.mc_uuid, state: state });
        if (response.status == 200)
            user_data.donor = state;
    }
</script>

<div>
    <UserCard user_data={user_data} />
    <button on:click={ban_user(!user_data.banned)}>
        <span><Icon icon="ri:auction-{user_data.banned ? "fill" : "line"}" width=20 /></span>
        {user_data.banned ? "Unban" : "Ban"}
    </button>
    <button on:click={make_donor(!user_data.donor)}>
        <span><Icon icon="ri:hand-heart-{user_data.donor ? "fill" : "line"}" width=20 /></span>
        {user_data.donor ? "Undo donor" : "Make donor"}
    </button>
</div>

<style>
    button {
        padding: 4px 8px;
        background-color: initial;
        border: 1px solid #cacaca;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 5px;
    }

    button:hover {
        background-color: #eeeeee;
        border-color: #cacaca;
    }

    button span {
        vertical-align: middle;
        margin-right: 5px;
    }

    div {
        margin-bottom: 10px;
    }
</style>